// extracted by mini-css-extract-plugin
module.exports = {"image":"TargetVideo_image___4cK_"};